import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/census';

export class CensusService extends RestServiceConnection {


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE CENSOS
     * @EN GETS THE LIST OF CENSUS
     */
    // -------------------------------------------------------------------------------------------------------------
    listCensus = async (filters?: any) => {
        // add filter is_ofc to false
        filters.filter_filters.isOfc = false;
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE OFC (OBJETO FUERA DE CENSO)
     * @EN GETS THE LIST OF OFC (OBJECT OUTSIDE CENSUS)
     */
    // -------------------------------------------------------------------------------------------------------------
    listOfc = async (filters?: any) => {
        // add filter is_ofc to true
        filters.filter_filters.isOfc = true;
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }   
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN CENSO POR SU ID
     * @EN GETS A CENSUS BY ITS ID
     * 
     * @param censusId
     */
    // -------------------------------------------------------------------------------------------------------------
    getCensusById = async (censusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { id : censusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN CENSO
     * @EN CREATES A CENSUS
     * 
     * @param census
     */
    // -------------------------------------------------------------------------------------------------------------
    createCensus = async (census: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: census,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    importCensus = async (formData: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/import',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }

    importOfc = async (formData: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/import-ofc',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UN CENSO
     * @EN UPDATES A CENSUS
     * 
     * @param census
     */
    // -------------------------------------------------------------------------------------------------------------
    editCensus = async (census: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: census,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN CENSO
     * @EN DELETES A CENSUS 
     * 
     * @param censusId
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteCensus = async (censusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { 
                id : censusId 
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS CENSOS
     * @EN DELETES MULTIPLE CENSUS
     * 
     * @param censusIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiCensus = async (censusIds: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { censusIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA LOS ESTDOS DE LOS CENSOS
     * @EN GETS THE LIST OF CENSUS STATUS
     */
    // -------------------------------------------------------------------------------------------------------------
    listStatusCensus = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-status',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CAMBIA EL ESTADO DE UN CENSO
     * @EN CHANGES THE STATE OF A CENSUS
     * 
     * @param censusId
     * @param statusId
     */
    // -------------------------------------------------------------------------------------------------------------
    changeStatusCensus= async (censusId: string, statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-status',
            data: { 
                id: censusId,
                statusId: statusId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EXPORTA A EXCEL
     * @EN EXPORTS TO EXCEL
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    exportToExcel = async (filters?: any, isOfc?: boolean) => {
        filters.filter_filters.isOfc = isOfc;
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/export-to-excel',
            data: filters,
            responseType: 'blob',
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA LOS ESTDOS DE CARROÑAS
     * @EN GETS THE LIST OF CARRION STATUS
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelectStatus = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select-status',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES VALIDA VARIOS CENSOS
     * @EN VALIDATES MULTIPLE CENSUS
     * 
     * @param censusIds
     */
    // -------------------------------------------------------------------------------------------------------------
    validateSelectedCensus = async (censusIds: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/validate-multiple',
            data: { ids : censusIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

}
